import { useContext } from 'react';

import { ApplicationContext } from './ApplicationsContext';

export const useApplication = () => {
  return useContext(ApplicationContext);
};
